import React from "react";
import { DSTypography } from "../../../system-design/Typography";
import DSCircularProgress from "../../../system-design/DSCircularProgress";

type GreetingPreviewProps = {
  greet: string | null;
  isLoading: boolean;
  isError: boolean;
};

const GreetingPreview = ({
  greet,
  isLoading,
  isError,
}: GreetingPreviewProps) => {
  if (!greet && !isLoading && !isError) {
    return (
      <DSTypography fontFamily={"Gilroy-Medium"} sx={{ mt: 2 }}>
        Ready to create something special? Enter the details and hit Generate!
      </DSTypography>
    );
  }

  if (isLoading) {
    return <DSCircularProgress size={24} />;
  }

  if (isError) {
    return (
      <DSTypography color="error" sx={{ mt: 1 }}>
        Something went wrong. Please try again later.
      </DSTypography>
    );
  }

  return greet ? (
    <DSTypography sx={{ mt: 2, fontFamily: "Gilroy-Medium" }}>
      {greet}
    </DSTypography>
  ) : null;
};

export default GreetingPreview;
